import SinoAvisos from 'components/Avisos/SinoAvisos';

const Cabecalho = ({ user, avisos }) => (
	<>
		<div className="header-main">
			<div className="header-left">
				<div className="logo-name">
					<div className="logo buttonHeaderLogo">
						{/* <button
              style={{ border: "none" }}
              className="sidebar-icon"
              onClick={() => props.collapsed()}
            >
              <span className="fa fa-bars" />
            </button> */}
					</div>
				</div>
				<div className="clearfix"> </div>
			</div>
			<div className="header-right">
				<div className="profile_details">
					<ul>
						<li>
							<div className="profile_img">
								<div className="user-name">
									<p>{user.login}</p>
								</div>
							</div>
						</li>
					</ul>
				</div>
				{/* Depois do bloco do usuário no DOM porque ambos são float:right —
				    assim o sino fica à esquerda do nome, e não acima dele. */}
				<SinoAvisos
					naoLidos={avisos?.naoLidos ?? 0}
					ultimos={avisos?.ultimos ?? []}
					marcarTodosLidos={avisos?.marcarTodosLidos ?? (() => {})}
				/>
				<div className="clearfix"> </div>
			</div>
			<div className="clearfix"> </div>
		</div>
	</>
);

export default Cabecalho;
